// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"354":"364d7c1ea8b8b3f3d233","399":"e2d4c27e5654d21fa81c","785":"ae53f00a84dbde0341fb"}[chunkId] + ".chunk.js";
};